import {Popover as AntPopover} from "antd";

export const Popover = AntPopover;
export default Popover;
